<template>
	<template v-if="!isComplete">
		Загружается...
	</template>
	<template v-else>
        <div>
            <ul class="nav nav-tabs nav-justified pb-4">
                <li class="nav-item">
                    <a 
                        class="nav-link" 
                        @click.prevent="setTabActive('tabRoad')" 
                        :class="{ 
                            active: isTabActive('tabRoad'),
                            'marker-new':  isModfiedClass('list')
                        }" 
                        href="#tabRoad">
                        Лист согласования маршрута
                    </a>
                </li>
                <li class="nav-item">
                    <a 
                        class="nav-link" 
                        @click.prevent="setTabActive('tabServices')" 
                        :class="{ 
                            active: isTabActive('tabServices'),
                            'marker-new': isModfiedClass('imar')
                        }"
                        href="#tabServices">
                        Услуги ИМАР
                    </a>
                </li>
            </ul>

            <div class="tab-content card-content" id="imarTabContent">
                <div class="tab-pane fade" :class="{ 'active show': isTabActive('tabServices') }" id="tabServices">
                    <div v-if="!isShowTabImar">
                        <div class="my-5">
                            Не запущен процесс Формирования ИМАР
                            <div class="card-footer mt-5">
                                <div class="d-flex align-items-center float-right">
                                    <button-component kind="secondary" type="button" class="btn btn-default" v-on:click="close">Закрыть</button-component>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-else>
                        <div>

                            <div class="mb-4 d-flex justify-content-end">
                                <template v-for="el in kindActivityList" v-bind:key="el.id">
                                    <button v-on:click="kindActivityId = el.id" class="btn btn-info btn-sm m-1"
                                            :class="{ 'active': kindActivityId == el.id }">{{ el.text }}
                                    </button>
                                </template>
                            </div>

                            <template v-if="!isComplete">
                                Загружается...
                            </template>
                            <template v-if="!currentRoute">
                                <div class="my-5">Не запущен процесс формирования ИМАР</div>
                            </template>
                            <template v-if="isComplete && isRouteLoaded && itemsFilter && Object.keys(itemsFilter).length > 0">
                                <div v-for="(items, key, idx) in itemsFilter" :key="key" class="row">
                                    <template v-if="idx === 0">
                                        <template v-if="!key.includes('Новый маршрут') && currentRoute">
                                            <div class="form-group  d-flex flex-wrap align-items-center solid justify-content-between mt-3" >
                                                <h4
                                                    :class="{
                                                        'marker-new': 
                                                            checkModifiedItem(items && items.length && items[0]?.journalRouteId,3) || 
                                                            checkModifiedItem(items && items.length && items[0]?.journalRouteId,4) ||
                                                            checkModifiedItem(items && items.length && items[0]?.journalRouteId,9) ||
                                                            checkModifiedItem(items && items.length && items[0]?.id,9)
                                                    }" 
                                                    class="m-0">
                                                    Новый маршрут абилитации и реабилитации
                                                </h4>
                                                <div class="d-flex flex-wrap">
                                                    <button-component type="button" class="btn-primary justify-content-center btn-sm card-footer__btn white my-2 width-auto" 
                                                                    v-if="isActive && !isReadonly"
                                                                    v-on:click="create">Создать</button-component>
                                                </div>                                         
                                            </div>
                                            <EmptyListMessage/>
                                        </template>
                                        <div class="form-group  d-flex flex-wrap align-items-center solid justify-content-between mt-3" >
                                            <h4
                                                :class="{
                                                    'marker-new': 
                                                        checkModifiedItem(items && items.length && items[0]?.journalRouteId,3) ||
                                                        checkModifiedItem(items && items.length && items[0]?.journalRouteId,4) ||
                                                        checkModifiedItem(items && items.length && items[0]?.journalRouteId,9) ||
                                                        checkModifiedItem(items && items.length && items[0]?.id,9)
                                                }"  
                                                class="my-2">
                                                {{key}}
                                            </h4>
                                            <div v-if="!key.includes('Новый маршрут')" class="d-flex flex-wrap align-items-center justify-content-between">
                                              <button-component v-if="getIsButtonVisible(items)" type="button" class="btn-primary justify-content-center btn-sm card-footer__btn white my-2 width-auto mr-2"
                                                              v-on:click="exportPdf(items)">Печать</button-component>       
                                              <button-component type="button" class="btn-primary justify-content-center btn-sm card-footer__btn white my-2 width-auto"
                                                              v-on:click="expand(key)">{{expanded[key] ? 'Свернуть' : 'Развернуть'}}</button-component>       
                                            </div>
                                            <div v-else class="d-flex flex-wrap align-items-start" style="min-height: 20px">
                                                <button-component type="button" class="btn-primary justify-content-center btn-sm card-footer__btn white my-2 width-auto" 
                                                                v-if="isActive && !isReadonly && imarEditable(items)"
                                                                v-on:click="create">Создать</button-component>
                                                <button-component type="button" kind="secondary" class="justify-content-center btn-sm card-footer__btn white my-2 width-auto mx-2"
                                                                v-if="isActive && canEditImar  && imarEditable(items)" v-on:click="confirm">Отправить на согласование</button-component> 
                                                <div v-if="!getSendToApprovalState(items).enabled" class="mx-2 my-2 send-approval-block" :title="getSendToApprovalState(items).reason || ''">
                                                    <button-component type="button" kind="secondary" class="justify-content-center btn-sm card-footer__btn white width-auto"
                                                                    :disabled="true">
                                                        Отправить на согласование
                                                        <sup v-if="getSendToApprovalState(items).reason"><i class="fa fa-info-circle text-gray" :title="getSendToApprovalState(items).reason"></i></sup>
                                                    </button-component>
                                                    <div v-if="getSendToApprovalState(items).reason" class="send-approval-reason" style="display:none;">
                                                        {{ getSendToApprovalState(items).reason }}
                                                    </div>
                                                </div>
                                            </div>                                                                                           
                                        </div>

                                    </template>
                                    <template v-if="isComplete && idx > 0">
                                        <div class="form-group  d-flex flex-wrap align-items-center solid justify-content-between mt-3">
                                                <h4
                                                    :class="{
                                                        'marker-new': 
                                                            checkModifiedItem(items && items.length && items[0]?.journalRouteId,3) ||
                                                            checkModifiedItem(items && items.length && items[0]?.journalRouteId,4) ||
                                                            checkModifiedItem(items && items.length && items[0]?.journalRouteId,9) ||
                                                            checkModifiedItem(items && items.length && items[0]?.id,9)
                                                    }"  
                                                    class="m-0">
                                                    {{key}}
                                                </h4>
                                                <div class="d-flex flex-wrap align-items-center justify-content-between">
                                                  <button-component v-if="getIsButtonVisible(items)" type="button" class="btn-primary justify-content-center btn-sm card-footer__btn white my-2 width-auto mr-2"
                                                              v-on:click="exportPdf(items)">Печать</button-component>                                    
                                                  <button-component type="button" class="btn-primary justify-content-center btn-sm card-footer__btn white my-2 width-auto"
                                                                  v-on:click="expand(key)">{{expanded[key] ? 'Свернуть' : 'Развернуть'}}</button-component>                                          
                                                </div>   
                                        </div>
                                    </template>
                                    <div  v-if="expanded[key] || key.includes('Новый маршрут') ">
                                        <dropdown v-for="item in items" :key="item.id">
                                            <template v-slot:title>
                                                <span :class="{
                                                    'text-red': item.actionRefuse,
                                                    'marker-new': 
                                                        checkModifiedItem(item.id,2) ||
                                                        checkModifiedItem(item.id,9)
                                                }">
                                                    {{item.serviceTypeName}}
                                                </span>
                                            </template>
                                            <template v-slot:text>
                                                {{ $momentFormat(item.dateBegin, "DD.MM.YYYY") }} - {{ $momentFormat(item.dateEnd, "DD.MM.YYYY") }}
                                            </template>
                                            <template v-slot:actions>
                                                <div v-if="!isDeleted && !isReadonly && ((!item.confirmed && imarEditable(items)) || imarSpecialDelete(item))">
                                                    <i class="fas fa-trash mx-2" title="Удалить" @click.stop="deleteCard(item.id)"></i>
                                                </div>
                                                <div>
                                                <i class="fas fa-eye mx-2" @click.stop="viewCard(item.id)" title="Просмотр"></i>
                                                </div>
                                                <div v-if="!isReadonly && !item.confirmed && (imarEditable(items) || imarSpecialEdit(item))">
                                                <i class="fas fa-pen mx-2" title="Редактирование" @click.stop="editCard(item.id)"></i>
                                                </div>
                                            </template>
                                            <template v-slot:default>
                                            <div>
                                                
                                                <h4 class="mb-4">Общая информация</h4>
                                                <div class="table-inner mb-4">
                                                    <table class="table-custom">
                                                        <thead>
                                                        <tr>
                                                            <th  class="col1" >Услуга</th>
                                                            <th width="80px" class="col2">Объем</th>
                                                            <th width="100px" class="col3">Периодичность</th>
                                                            <th width="240px" class="col4">Срок предоставления услуги</th>
                                                            <th width="100px" class="col5">Отметка о выполнении</th>
                                                            <th width="100px" class="col5">Расписание</th>
                                                        </tr>
                                                        </thead>
                                                        <tbody>
                                                        <tr>
                                                            <td class="col1" >{{ item.serviceTypeName }}</td>
                                                            <td class="col2">{{ item.count }}</td>
                                                            <td class="col3">{{ item.period }}</td>
                                                            <td class="col4">{{ $momentFormat(item.dateBegin, "DD.MM.YYYY") }} - {{
                                                                    $momentFormat(item.dateEnd, "DD.MM.YYYY")
                                                                }}
                                                            </td>
                                                            <td class="col5">
                                                                <Checkbox :id="'isCompleted_' + item.id" v-bind:modelValue="item.isCompleted" class="text-center" :disabled="true"/>
                                                            </td>
                                                            <td class="col5">{{ item.schedule }}</td>
                                                        </tr>
                                                        </tbody>
                                                    </table>
                                                </div>

                                                <template v-if="item.actionRefuse">
                                                    <h4>Отказ от услуги</h4>
                                                    <div class="table-inner mb-4">
                                                    <table class="table-custom">
                                                        <thead>
                                                        <tr>
                                                            <th>Отметка об отказе</th>
                                                            <th>Причина отказа</th>
                                                            <th>Инициатор отказа</th>
                                                            <th>Дата отказа</th>
                                                        </tr>
                                                        </thead>
                                                        <tbody>
                                                        <tr>
                                                            <td><Checkbox :id="'refused_' + item.id" v-bind:modelValue="true" :disabled="true"/></td>
                                                            <td>{{ item.actionRefuse.comment }}</td>
                                                            <td>{{ item.actionRefuse.createdBy }}</td>
                                                            <td>{{ $momentFormat(item.actionRefuse.created, "DD.MM.YYYY") }}</td>
                                                        </tr>
                                                        </tbody>
                                                    </table>  
                                                    </div>                      
                                                </template>

                                                <!--                    <div class="table-inner col-4 mb-4">-->
                                                <!--                        <table class="table-custom">-->
                                                <!--                            <thead>-->
                                                <!--                            <tr>-->
                                                <!--                                <th>Услуга оказывается?</th>-->
                                                <!--                                <th>Резюме</th>-->
                                                <!--                            </tr>-->
                                                <!--                            </thead>-->
                                                <!--                            <tbody>-->
                                                <!--                            <tr v-for="item in itemsFilter" :key="item.id">-->
                                                <!--                                <td class="col-3">-->
                                                <!--                                    <Checkbox :checked="isConfirmed" disabled/>-->
                                                <!--                                </td>-->
                                                <!--                                <td class="col-3">{{item.resume}}</td>-->
                                                <!--                            </tr>-->
                                                <!--                            </tbody>-->
                                                <!--                        </table>-->
                                                <!--                    </div>-->

                                                <template v-if="item.organizations && item.organizations.length > 0">
                                                <div class="mb-4"><h4>Организации</h4></div>
                                                <div class="table-inner mb-4">
                                                    <table class="table-custom">
                                                        <thead>
                                                        <tr>
                                                            <th >Название</th>
                                                            <th width="100px">ОГРН</th>
                                                            <th width="100px">ИНН</th>
                                                            <th width="100px">КПП</th>
                                                            <th width="215px">Адрес</th>
                                                            <th width="115px" >Заявление</th>
                                                            <th width="120px">Договор</th>
                                                            <th width="100px">Сотрудники</th>
                                                            <th width="120px">Найти на карте</th>
                                                            <th v-if="messenger.isAvailable && item.isConfirmed">Мессенджер</th>
                                                        </tr>
                                                        </thead>
                                                        <tbody>
                                                        <tr v-for="(org, idx) in item.organizations" :key="org.id" :class="{'text-green': org.isActive}">
                                                            <td class="col1">{{ org.name }}</td>
                                                            <td>{{ org.ogrn }}</td>
                                                            <td>{{ org.inn }}</td>
                                                            <td>{{ org.kpp }}</td>
                                                            <td>{{ org.address }}</td>
                                                            <td>
                                                                <div>
                                                                    <file-download :file="org.statementFile"/>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div>
                                                                    <file-download :file="org.contractFile"/>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div v-if="org.employees && org.employees.length > 0" @click.stop="handlerEmplShow(org.employees)" class="text-center"><i
                                                                    class="fas fa-eye"></i></div>
                                                            </td>
                                                            <td class="col5">
                                                                <div @click="findOnMap(org, item.kindActivityId, idx)" class="text-center"><i class="fas fa-map"></i></div>
                                                            </td>
                                                            <td v-if="messenger.isAvailable && item.isConfirmed" class="text-center">
                                                                <div class="messenger" @click="openMessenger(org.itemId)">
                                                                <i class="far fa-comments"></i>
                                                                <span :class="{'text-bold':org.unreadMessageCount > 0}">{{org.unreadMessageCount}}</span>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                                </template>

                                                <template v-if="item.isOrganizationChoose">
                                                    <h4>Посещаемость</h4>
                                                    <div class="table-inner mb-4">
                                                    <table class="table-custom" v-if="item.visits && item.visits.length > 0">
                                                        <thead>
                                                        <tr>
                                                            <th width="130px">Дата занятия</th>
                                                            <th width="282px">Отметка о посещении</th>
                                                            <th>Вложение</th>
                                                            <th>Результаты посещений</th>
                                                            <th>Оценка</th>
                                                        </tr>
                                                        </thead>
                                                        <tbody>
                                                        <tr v-for="(visit) in item.visits" v-bind:key="visit.id">
                                                            <td>{{ $momentFormat(visit.dateVisit, "DD.MM.YYYY") }}</td>
                                                            <td>{{ visit.markType }}</td>
                                                            <td>
                                                                <div>
                                                                    <file-download :file="visit.file"/>
                                                                </div>
                                                            </td>
                                                            <td>{{ visit.result }}</td>
                                                            <td>{{ visit.mark }}</td>
                                                        </tr>
                                                        <tr v-if="item.isCompleted">
                                                            <td></td>
                                                            <td></td>
                                                            <td></td>
                                                            <td>Итоговый результат: <div>{{ item.resume }}</div></td>
                                                            <td></td>
                                                        </tr>
                                                        </tbody>
                                                    </table>
                                                    <button-component
                                                        type="button"
                                                        class="btn btn-sm btn-primary mt-2"
                                                        v-on:click="addVisit(item.id)"
                                                        v-if="!item.actionRefuse && !isReadonly">Добавить информацию о занятии</button-component>
                                                    </div>
                                                </template>
                                            </div>
                                            </template>
                                        </dropdown>
                                    </div>
                                </div>
                            </template>
                            <template v-else>
                                <div class="form-group  d-flex flex-wrap align-items-center solid justify-content-between mt-3">
                                    <h4
                                        :class="{
                                            'marker-new': 
                                                checkModifiedItem(items && items.length && items[0]?.journalRouteId,3) ||
                                                checkModifiedItem(items && items.length && items[0]?.journalRouteId,4) ||
                                                checkModifiedItem(items && items.length && items[0]?.journalRouteId,9) ||
                                                checkModifiedItem(items && items.length && items[0]?.id,9)
                                            }"  
                                        class="m-0">
                                        Новый маршрут абилитации и реабилитации
                                    </h4>
                                    <div class="d-flex flex-wrap">
                                        <button-component type="button" class="btn-primary justify-content-center btn-sm card-footer__btn white my-2 width-auto" 
                                                        v-if="isActive && !isReadonly"
                                                        v-on:click="create">Создать</button-component>
                                    </div>                                        
                                </div>                            
                                <EmptyListMessage/>
                            </template>

                            <div class="mt-4 mb-1 d-flex" v-if="false">
                                <button-component type="button" class="btn btn-primary mx-2" v-if="isActive && !isReadonly"
                                                v-on:click="create">Создать</button-component>
                                <button-component type="button" kind="secondary" class="btn btn-success mx-2"
                                                v-if="isActive && canEditImar" v-on:click="confirm">Закончить</button-component>
                            </div>


                        <div class="card-footer mt-5">
                            <div class="d-flex align-items-center float-right">
                                <button-component kind="secondary" type="button" class="btn btn-default" v-on:click="close">Закрыть</button-component>
                            </div>
                        </div> 
                            <section class="modals">
                                <modal-component v-if="mapShow">
                                    <div>
                                        <l-map v-if="mapShow" ref="myMap" style="height:50vh"
                                            :zoom="10"
                                            :center="mapCurrentCenter">
                                            <l-tile-layer
                                                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                                            ></l-tile-layer>
                                            <template v-for="el in organizationList" :key="el.id">
                                                <l-marker v-if="el.lat && el.lng"
                                                        :lat-lng="el" :icon="getMarkerIcon(el.kindActivityId, el.addressId)"
                                                >
                                                    <l-popup>
                                                        <div>{{ el.name }}</div>
                                                        <div>{{ el.address }}</div>
                                                        <div class="link pt-2" v-on:click="setAddress(el)" v-if="!isReadonly">Выбрать</div>
                                                    </l-popup>
                                                </l-marker>
                                            </template>

                                        </l-map>
                                        <div class="mt-1">
                                            <div class="float-right">
                                                <button type="button" class="btn btn-default" v-on:click="mapShow=false">Закрыть карту</button>
                                            </div>
                                        </div>
                                    </div>
                                </modal-component>
                                <modal-component v-show="emplShow" title="Сотрудники" @close="emplShow = false">
                                    <table v-if="employees.length" class="table-custom">
                                        <thead>
                                        <tr>
                                            <th>Фамилия</th>
                                            <th>Имя</th>
                                            <th>Отчество</th>
                                            <th>Должность</th>
                                            <th>Телефон</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr v-for="(empl, idx) in employees" :key="idx">
                                            <td>{{ empl.surname }}</td>
                                            <td>{{ empl.name }}</td>
                                            <td>{{ empl.patronymic }}</td>
                                            <td>{{ empl.position }}</td>
                                            <td>{{ empl.phone }}</td>
                                        </tr>
                                        </tbody>
                                    </table>
                                    <div v-else>Сотрудников нет</div>
                                </modal-component>
                                <modal-component v-if="modals.show" title="Карточка услуги" @close="modals.show = false">
                                    <imar-service-card :card-id="modals.id" :journal-id="journalId" :is-readonly="modals.isReadonly"
                                                    @close="modals.show = false" @save="modals.show = false;loadPage();"/>
                                </modal-component>
                                <modal-component v-if="visitModal.show" title="Карточка услуги" @close="visitModal.show = false" size-class="modal-xs">
                                    <imar-visit-card :card-id="visitModal.id" :journal-imar-id="visitModal.journalImarId"
                                                    @close="visitModal.show = false" @save="visitModal.show = false;loadPage();"/>
                                </modal-component>
                                <modal-component v-if="messenger.show" title="Мессенджер" class="modal-content--card"
                                                @close="messenger.show = false">
                                    <MessengerForm :filter="messenger.filter"></MessengerForm>
                                </modal-component>
                            </section>

                        </div>
                    </div>
                </div>
                <div class="tab-pane fade" :class="{ 'active show': isTabActive('tabRoad') }" id="tabRoad">
                    <PassingRouteComponent 
                        :responseStatusOfChange="responseStatusOfChange" 
                        :journalId="journalId" 
                        :isReadonly="isReadonly"
                        @reload="reload(true)"
                        @reloadSimple="reloadCurrentRoute()"
                    />
                </div>
            </div>
        </div>
    </template>
</template>
<script>
import API from '../api/imar'
import API_ROUTE from '../api/route'
import Constants from '@/common/constants'
import Utils from "../../../common/utils";

import { LMap, LMarker, LTileLayer,  } from "@vue-leaflet/vue-leaflet";
import {latLng} from "leaflet";

import ButtonComponent from "@/common/ui/ButtonComponent";
import PassingRouteComponent from '../components/PassingRouteComponent.vue';
import FileDownload from "../../../common/components/FileDownload";
import Dropdown from "@/modules/journal/components/Dropdown";
import Checkbox from "@/common/ui/checkbox";
import MessengerForm from "../../messenger/components/MessengerForm";
import ModalComponent from "@/common/ui/ModalComponent";
import ImarServiceCard from '../views/ImarServiceCard.vue';
import ImarVisitCard from '../views/ImarVisitCard.vue';

import security from "@/common/mixins/security";

export default {
    name: "JournalTabImar",
    components: {
      MessengerForm,
        ButtonComponent,
        Checkbox,
        Dropdown,
        ImarServiceCard,
        ImarVisitCard,
        ModalComponent,
        FileDownload,
        LMap,
        LMarker,
        LTileLayer,
        PassingRouteComponent
    },
    mixins: [security],
    props: {
        journalId: Number,
        isActive: Boolean,
        currentSignerId: Number,
        isReadonly:{
            type: Boolean,
            required: false,
            default: false
        },
        isShowTabImar: {
            type: Boolean,
            required: false,
            default: false
        },
        responseStatusOfChange: Array,
        parsedStatusOfChange: Object,
    },
    mounted() {

    },
    data: () => ({
            activeItem: 'tabServices',
            organizationList: [],
            mapCurrentCenter: latLng(56.30, 44.01),
            mapIndex: null,
            mapAddressId: null,
            employees: [],
            emplShow: false,
            mapShow: false,
            items: [],
            isComplete: false,
            isRouteLoaded: false,
            modals: {
                show: false,
                id: null,
                isReadonly: false
            },
            visitModal: {
                show: false,
                id: null,
                journalImarId: null
            },
            messenger: {
              isAvailable: false,
              filter: {
                dialogType: null,
                patientId: null,
                journalImarOrganizationId: null
              },
              show: false
            },
            kindActivityId: 0,
            kindActivityList: [
                {id: 0, text: 'все', selected: true},
            ],
            expanded: {},
            canEditImar: false,
            currentRoute: null,
            specialDeleteImar: false,
            specialDeleteImarAfterStep1: false,
            specialDeleteImarAfterStep2: false,
            specialEditImar: false,
            specialEditImarAfterStep1: false,
            specialEditImarAfterStep2: false,
        }
    ),
    created() {
        this.checkPermission(Constants.OrgServicesChat)
            .then((response) => {
                this.messenger.isAvailable = response.data;
            });
        if (!this.isReadonly) {
            this.checkPermission(Constants.JournalImarEdit)
                .then((response) => {
                this.canEditImar = response.data;
                });
        }

        /* загружаем спец.права на удаление/редактирование имара */
        this.checkPermission(Constants.JournalImarSpecialDelete)
            .then((response) => {
                this.specialDeleteImar = response.data;
            });
        this.checkPermission(Constants.JournalImarSpecialDeleteAfterStep1)
            .then((response) => {
                this.specialDeleteImarAfterStep1 = response.data;
            });
        this.checkPermission(Constants.JournalImarSpecialDeleteAfterStep2)
            .then((response) => {
                this.specialDeleteImarAfterStep2 = response.data;
            });
        this.checkPermission(Constants.JournalImarSpecialEdit)
            .then((response) => {
                this.specialEditImar = response.data;
            });
        this.checkPermission(Constants.JournalImarSpecialEditAfterStep1)
            .then((response) => {
                this.specialEditImarAfterStep1 = response.data;
            });
        this.checkPermission(Constants.JournalImarSpecialEditAfterStep2)
            .then((response) => {
                this.specialEditImarAfterStep2 = response.data;
            });
        /* -- загружаем спец.права на удаление/редактирование имара */

        this.loadPage();
        Utils.loadSelectOptions("kindActivity", this.kindActivityList);
    },
    watch: {
        journalId: function (/*newValue, oldValue*/) {
            this.loadPage();
        }
    },
    computed: {
        itemsFilter() {
            if(!this.items)
                return [];
            var self = this;
            var res = this.items.filter(el => {
                return self.kindActivityId <= 0 || el.kindActivityId == self.kindActivityId;
            });
            var resReduced = res.reduce((grouped, item) =>{
                const key = item['journalRouteName']
                if (!grouped[key]) {
                    grouped[key] = [];
                }
                // Add object to list for given key's value
                grouped[key].push(item);
                return grouped;                
            }, {})
            return resReduced;
        },
    },
    emits: ['reload'],
    methods: {
        reload(hot) {
          if (hot)
            this.$emit('reload');
          else
            this.loadPage();
        },
        isTabActive (menuItem) {
        return this.activeItem === menuItem
        },
        setTabActive (menuItem) {
        this.activeItem = menuItem
        },         
        expand(key) {
            if (!this.expanded[key])
                this.expanded[key] = true;
            else
                this.expanded[key] = false;
        }, 
        getMarkerIcon(kindActivityId, isTemp) {
            return Utils.getMarkerIcon(kindActivityId, isTemp);
        },
        setAddress(el) {
            var orgItem = this.item.journalImarOrganizations[this.mapIndex];
            if (orgItem.organizationId != el.id) {
                orgItem.organizationId = el.id;
                this.changeOrganization(orgItem);
            }

            orgItem.addressId = el.addressId;
            this.mapShow = false;
            this.mapIndex = null;
        },
        findOnMap(el, kindActivityId, index) {
            el.kindActivityId = kindActivityId;
            this.organizationList = [el]
            this.mapShow = true;
            this.mapIndex = index;

            if(el.lat && el.lng) 
                this.mapCurrentCenter = latLng(el.lat, el.lng);
        },

        loadPage() {
            if (this.journalId > 0) {
                this.isComplete = false;
                let self = this;
                API.search({journalId: this.journalId}).then((resp) => {
                    self.items = resp.data;
                })
                .finally(() => {
                  self.isComplete = true;
                });
          this.isRouteLoaded = false;
          API_ROUTE.current({journalId: this.journalId}).then((response) => {
            this.currentRoute = response.data;
          })
          .finally(() => {
            this.isRouteLoaded = true;
          });
        }  //else {
                // this.isComplete = true;
              //} 

        },
        reloadCurrentRoute() {
            API_ROUTE.current({journalId: this.journalId}).then((response) => {
                this.currentRoute = response.data;
            });
        },
        create() {
            this.modals.id = 0;
            this.modals.show = true;
            this.modals.isReadonly = false;
        },
        viewCard(id) {
            this.modals.id = id;
            this.modals.show = true;
            this.modals.isReadonly = true;
        },
        editCard(id) {
            this.modals.id = id;
            this.modals.show = true;
            this.modals.isReadonly = false;
        },
        deleteCard(id) {
            var self = this;
            Constants.alert.fire(Constants.confirmOptions.delete).then((res) => {
                if (res.isConfirmed) {
                    API.delete(id).then(function (response) {
                        Constants.alert.fire('Удаление', response.data.message, response.data.success ? 'success' : 'error');
                        self.loadPage();
                    })
                }
            });
        },
        getSendToApprovalState(items) {
            if (this.isReadonly) {
                return { enabled: false, reason: 'Карточка открыта в режиме просмотра.' };
            }

            if (!this.canEditImar) {
                return { enabled: false, reason: 'Недостаточно прав для отправки ИМАР на согласование.' };
            }

            if (!items || items.length === 0) {
                return { enabled: false, reason: 'Добавьте хотя бы одну услугу ИМАР.' };
            }

            if (items[0].isConfirmed) {
                return { enabled: false, reason: 'ИМАР уже утвержден.' };
            }

            if (items[0].journalRouteId != this.currentRoute.id) {
                return { enabled: false, reason: 'Обнаружено несоответствие данных маршрута, код 103. Обновите страницу или обратитесь в техподдержку.' };
            }

            if (!this.currentRoute) {
                return { enabled: false, reason: 'Обнаружено несоответствие данных маршрута, код 101. Обновите страницу или обратитесь в техподдержку.' };
            }

            if (this.currentRoute.stepsDto && this.currentRoute.stepsDto.length > 0 && this.currentRoute.stepsDto[0].isComplete) {
                return { enabled: false, reason: 'ИМАР уже отправлен на согласование.' };
            }

            if (!this.currentSignerId) {
                return { enabled: false, reason: 'Обнаружено несоответствие данных маршрута, код 102. Обновите страницу или обратитесь в техподдержку.' };
            }            

            if (!this.isActive) {
                return { enabled: false, reason: 'Обнаружено несоответствие данных маршрута, код 104. Обновите страницу или обратитесь в техподдержку.' };
            }

            return { enabled: true, reason: null };
        },
        imarEditable(items) {
            //условие когда можно редактировать/удалять обычному пользователю услуги
            if (
                items &&
                items.length > 0 &&
                (
                    items[0].isConfirmed ||
                    (
                    this.currentRoute &&
                    (
                        items[0].journalRouteId != this.currentRoute.id ||
                        (
                            items[0].journalRouteId == this.currentRoute.id &&
                            //запущено согласование
                            this.currentRoute.stepsDto && this.currentRoute.stepsDto.length > 0 && this.currentRoute.stepsDto[0].isComplete
                        )
                    )
                    )
                )
            ) {
                return false;
            }
                //return false;

            // if (items && items.length > 0 && (items[0].isConfirmed || 
            //         this.currentRoute 
            //         && (items[0].journalRouteId != this.currentRoute.id || items[0].journalRouteId == this.currentRoute.id 
            //             && (this.currentRoute.stepsDto && this.currentRoute.stepsDto.length > 0 && this.currentRoute.stepsDto[0].isComplete))))
            //     return false;
            return true;
        },
        imarSpecialDelete(item) {
            //это услуга в маршруте, который как раз согласовывается, поэтому проверяем отдельное право
            if(item.journalRouteId == this.currentRoute?.id) {
                var currentStep = 0;
                if(this.currentRoute.stepsDto && this.currentRoute.stepsDto.length > 0) {
                    if(this.currentRoute.stepsDto[0].isComplete)
                        currentStep = 1;
                    if(this.currentRoute.stepsDto[1]?.isComplete)
                        currentStep = 2;
                    if(this.currentRoute.stepsDto[2]?.isComplete)
                        currentStep = 3;
                }
                //console.log(currentStep, "-- currentStep");
                if(currentStep == 1)//1 этап закончен
                    return this.specialDeleteImarAfterStep1;
                if(currentStep == 2)//2 этап закончен
                    return this.specialDeleteImarAfterStep2;
                if(currentStep == 3)//3 этап закончен - вообще сюда не должен попадать
                    return this.specialDeleteImar;

                return false;
            }
            
            //в не текущем маршруте отдельное право для удаления
            return this.specialDeleteImar;
        },
        imarSpecialEdit(item) {
            console.log(item.journalRouteId, "--imarSpecialEdit");
            console.log(this.currentRoute);

            //это услуга в маршруте, который как раз согласовывается, поэтому проверяем отдельное право
            if(item.journalRouteId == this.currentRoute?.id) {
                var currentStep = 0;
                if(this.currentRoute.stepsDto && this.currentRoute.stepsDto.length > 0) {
                    if(this.currentRoute.stepsDto[0].isComplete)
                        currentStep = 1;
                    if(this.currentRoute.stepsDto[1]?.isComplete)
                        currentStep = 2;
                    if(this.currentRoute.stepsDto[2]?.isComplete)
                        currentStep = 3;
                }
                //console.log(currentStep, "-- currentStep");
                if(currentStep == 1)//1 этап закончен
                    return this.specialEditImarAfterStep1;
                if(currentStep == 2)//2 этап закончен
                    return this.specialEditImarAfterStep2;
                if(currentStep == 3)//3 этап закончен - вообще сюда не должен попадать
                    return this.specialEditImar;

                return false;
            }

            if(this.currentRoute == null) {
                //тогда выбираем максимальный из items
                const maxRouteId = Math.max(...this.items.map(item => item.journalRouteId));
                if(maxRouteId == item.journalRouteId)//согласовано до конца
                    return this.specialEditImar;
            }

            return false;
        },
        addVisit(journalImarId) {
            this.visitModal = {
                show: true,
                journalImarId: journalImarId,
                id: null
            };
        },
        confirm() {
            var self = this;
            var options = {
                title: 'Подтверждение',
                text: 'Вы действительно закончили составление ИМАР?',
                confirmButtonText: 'Подвердить',
                cancelButtonText: 'Отмена',
                showCancelButton: true,
                icon: 'warning',
            };
            Constants.alert.fire(options).then((res) => {
                if (res.isConfirmed) {
                    API_ROUTE.confirmStep(self.currentSignerId).then(function (response) {
                        Constants.alert.fire('Завершение формирования ИМАР', response.data.message, response.data.success ? 'success' : 'error');
                        self.loadPage();
                        self.$emit('reload');
                    })
                }
            });
        },
        handlerEmplShow(el) {
            this.employees = el
            this.emplShow = true
        },
        openMessenger(id) {
            this.messenger.filter = {dialogType: 3, patientId: null, journalImarOrganizationId: id};
            this.messenger.show = true;
        },
        close() {
            this.$router.push({name: 'Journal', query: { page1: this.$route.query.page1 }});
        },
        exportPdf(items) {
          if (items && items.length) {
            let journalRouteId = items[0].journalRouteId;
            API.exportPdf(journalRouteId);
          }
        },
        getIsButtonVisible(items) {
          return items && items.every(x => x.isConfirmed === true);
        },
        isModfiedClass(item) {
            if(item == 'list')
                if (this.parsedStatusOfChange.imarStatus.active == true) 
                    return true;
                else return false;
            if(item == 'imar')
                if(
                    this.parsedStatusOfChange.serviceEnd.active == true ||
                    this.parsedStatusOfChange.imarEnd.active == true ||
                    this.parsedStatusOfChange.serviceNotBecome.active == true ||
                    this.parsedStatusOfChange.organization.active == true
                ){
                    return true;
                }
                else return false;
        },
        checkModifiedItem(id, statusId) {
          if (!id)
            return false;

          let check = false;
          let patientChangeId = statusId;
          if(this.responseStatusOfChange){
            this.responseStatusOfChange.findIndex(element => {
              if (element.itemId === id && element.patientChangeId === patientChangeId) {
                check = true;
                return check;
              }
              check = false;
              return check;
              });
            return check
          }
        }
    },
};
</script>

<style lang="scss" scoped>
@import '/src/assets/theme/default/colors.scss';

.table-inner {
    overflow: auto;
}

.btn-info {
    font-family: "Source Sans Pro", sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 120%;
    padding: 8px 20px;
    background: $gray-light2;
    border-radius: 20px;
    border: 1px solid $gray-light2;
    color: $black !important;

    &.active {
        color: $blue !important;
        background: rgba(67, 142, 240, 0.2) !important;
        border: 1px solid #438EF0 !important;
    }

    &:hover {
        color: $blue !important;
        background: rgba(67, 142, 240, 0.2) !important;
        border: 1px solid #438EF0 !important;
    }
}

.fas {
    color: $gray-medium
}

.messenger {
  cursor: pointer;
  color: $blue-light;
  span {
    margin-left: 8px;
  }
}

.card-footer{
    padding: 0;
    background-color: transparent;
    border: none;
}

.send-approval-block {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    max-width: 320px;
}

.send-approval-reason {
    margin-top: 6px;
    color: $gray-dark;
    font-size: 12px;
    line-height: 1.3;
}

.solid {
    background-color:#F5F5FA;//rgba(171,171,179, 0.1);
    line-height: 3rem;
    letter-spacing: 0.5px;
}

.nav-tabs {
    justify-content: center;
    border: none;

    .nav-item {
        margin-top: 12px;
        max-width: 300px;
        width: 100%;

        &:not(:last-child) {
            margin-right: 16px;
        }

        .nav-link {
            padding: 14.5px 20px;
            text-align: center;
            font-family: "Source Sans Pro", sans-serif;
            font-style: normal;
            font-weight: 600;
            font-size: 16px;
            line-height: 120%;
            color: $gray-dark;
            border: 1px solid $gray-light1;
            box-sizing: border-box;
            border-radius: 6px;

            &.active {
                color: $blue-light;
                border: 1px solid $blue-light;
            }
        }
    }
}
</style>
